import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { Logout } from '../../auth/store/actions/auth.actions';
import { State } from '../../auth/store';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpErrorService {
  private readonly store = inject<Store<State>>(Store);

  handleError(response: HttpErrorResponse, _url: string): Observable<HttpEvent<unknown>> {
    // console.log('handleError response', response);
    // console.log('handleError url', url);

    switch (response.status) {
      case 0: {
        const resp = response.error;
        const message = navigator.onLine
          ? 'Unable to reach the server. It may be unavailable or the request timed out. Please try again.'
          : 'No internet connection. Please check your network and try again.';
        return throwError(() => ({
          error: { ...resp, message },
        }));
      }

      case 302: {
        // handle session timeout
        this.store.dispatch(Logout());
        const resp = response.error;
        return throwError(() => ({
          error: { ...resp, message: 'Session timeout. Please, try again.' },
        }));
      }

      case 401: // Unauthorized
        this.store.dispatch(Logout());
        return throwError(() => response.error);

      default: {
        return throwError(() => response);
      }
    }
  }
}
